import { render } from "./listfooter.vue?vue&type=template&id=06812fa7"
import script from "./listfooter.vue?vue&type=script&lang=js"
export * from "./listfooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adi/Sites/yelp-ads/sweepstakes-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__